export const folderMailboxTicketIds = (folder, mailboxId) => {
  if (!folder) return null
  if (!folder.mailboxTickets) return null
  if (folder.mailboxTickets[mailboxId]) return folder.mailboxTickets[mailboxId]
  return null
}
